import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
    isLoading: boolean;
    message: string;
    type: string | null;
    scopes: Record<
        string,
        {
            isLoading: boolean;
            message: string;
        }
    >;
}

const initialState: LoadingState = {
    isLoading: false,
    message: '',
    type: null,
    scopes: {},
};

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        startLoading: (
            state,
            action: PayloadAction<{
                message?: string;
                type?: string;
                scope?: string;
            }>
        ) => {
            const { message = '', type = '', scope = '' } = action.payload;

            if (scope) {
                // Scoped loading
                state.scopes[scope] = {
                    isLoading: true,
                    message: message || 'Loading...',
                };
            } else {
                // Global loading
                state.isLoading = true;
                state.message = message || 'Loading...';
                state.type = type || null;
            }
        },
        stopLoading: (state, action: PayloadAction<{ scope?: string }>) => {
            const { scope = '' } = action.payload;

            if (scope) {
                // Scoped loading
                delete state.scopes[scope];
            } else {
                // Global loading
                state.isLoading = false;
                state.message = '';
                state.type = null;
            }
        },
    },
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
